import { NavigationMobile } from "./NavigationMobile";
import { NavigationDesktop } from "./NavigationDesktop";

export const NavigationMain = () => {
  return (
    <>
      <NavigationMobile />
      <NavigationDesktop />
    </>
  );
};
